/* ============================================================
   dr.GUT — Barra de frete grátis: transição entre dois estados

   A barra é calculada no servidor e vive dentro de #minicart-form, que
   é redesenhado por inteiro (innerHTML) a cada mudança do carrinho.
   O elemento que chega é OUTRO, e já nasce com a largura final — e
   `transition` no CSS não anima o primeiro valor de um elemento recém
   criado. Era daí que vinha o salto: não havia animação nenhuma, o
   valor simplesmente aparecia pronto.

   O conserto é dar ao elemento novo o estado ANTERIOR por um quadro e
   só então soltar o valor real: aí existem dois valores entre os quais
   transicionar, e o CSS anima. O mesmo vale para a bolinha do caminhão
   (--dg-ship-pos) e para o "Faltam R$ …", que conta até o novo valor.

   O percentual anterior é lembrado aqui em JS. O servidor continua
   sendo a fonte da verdade: ele diz onde a barra PARA, este arquivo só
   preenche o caminho até lá.
   ============================================================ */
(function () {
  'use strict';

  var DURACAO = 620;

  var barraAnterior = null;
  var pctAnterior = null;
  var faltaAnterior = null;
  var quadro = null;

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function pctDe(fill) {
    var n = parseFloat(fill && fill.style.width);
    return isFinite(n) ? n : 0;
  }

  /* ---------- dinheiro ----------
     O texto vem do filtro money do Liquid, já no formato da loja. Em vez
     de reformatar por conta própria, o número é lido de volta e devolvido
     no mesmo molde: o que vinha antes do primeiro dígito (o "R$ ") e a
     presença ou não de centavos são preservados. */
  function lerDinheiro(texto) {
    var digitos = texto.replace(/[^\d.,]/g, '');
    if (!digitos) return null;

    var prefixo = texto.slice(0, texto.search(/\d/));
    var sufixo = texto.slice(texto.search(/[\d.,]+$/) + digitos.length);
    var temCentavos = /[.,]\d{2}$/.test(digitos);

    /* Separador decimal é o último . ou , quando ele isola dois dígitos;
       o resto é separador de milhar e sai fora. */
    var valor = temCentavos
      ? parseFloat(digitos.slice(0, -3).replace(/[^\d]/g, '') + '.' + digitos.slice(-2))
      : parseFloat(digitos.replace(/[^\d]/g, ''));

    if (!isFinite(valor)) return null;
    return { valor: valor, prefixo: prefixo, sufixo: sufixo, centavos: temCentavos };
  }

  function escreverDinheiro(molde, valor) {
    var corpo = molde.centavos ? valor.toFixed(2) : String(Math.round(valor));
    var partes = corpo.split('.');
    partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return molde.prefixo + partes.join(',') + molde.sufixo;
  }

  /* ---------- a animação ---------- */
  function animar(barra, fill, valorEl, molde, dePct, paraPct, deFalta, paraFalta) {
    /* Um quadro no estado antigo, sem transição — é isso que dá ao
       navegador um ponto de partida para interpolar. */
    var transicaoOriginal = fill.style.transition;
    fill.style.transition = 'none';
    fill.style.width = dePct + '%';
    barra.style.setProperty('--dg-ship-pos', dePct + '%');

    /* Leitura forçada: sem ela o navegador junta as duas escritas e
       aplica só a última, que é justamente o salto que queremos evitar. */
    void fill.offsetWidth;

    fill.style.transition = transicaoOriginal;
    fill.style.width = paraPct + '%';
    barra.style.setProperty('--dg-ship-pos', paraPct + '%');

    if (valorEl == null || molde == null || deFalta == null) return;

    var textoFinal = valorEl.textContent;
    var inicio = null;

    cancelAnimationFrame(quadro);
    quadro = requestAnimationFrame(function passo(agora) {
      if (inicio === null) inicio = agora;

      var t = Math.min((agora - inicio) / DURACAO, 1);
      var atual = deFalta + (paraFalta - deFalta) * easeOutCubic(t);
      valorEl.textContent = escreverDinheiro(molde, atual);

      if (t < 1) {
        quadro = requestAnimationFrame(passo);
      } else {
        /* Fecha exatamente no texto do servidor: arredondamento próprio
           nunca decide o valor que fica na tela. */
        valorEl.textContent = textoFinal;
      }
    });
  }

  function verificar() {
    var barra = document.querySelector('.drgut-ship__bar');

    /* Mesmo elemento de antes: o carrinho não foi redesenhado. */
    if (!barra || barra === barraAnterior) return;

    var fill = barra.querySelector('.drgut-ship__fill');
    if (!fill) return;

    var pct = pctDe(fill);
    var valorEl = barra.parentNode.querySelector('.drgut-ship__text b');
    var molde = valorEl ? lerDinheiro(valorEl.textContent) : null;
    var falta = molde ? molde.valor : null;

    /* Na primeira vez a barra entra preenchendo desde o zero; nas
       seguintes, parte de onde ela realmente estava. Sem valor anterior
       para o texto (frete recém-conquistado, por exemplo), só a barra
       se move e o texto troca de uma vez. */
    var dePct = pctAnterior === null ? 0 : pctAnterior;
    var deFalta = pctAnterior === null ? null : faltaAnterior;

    if (dePct !== pct || (deFalta !== null && falta !== null && deFalta !== falta)) {
      animar(barra, fill, valorEl, molde, dePct, pct, deFalta, falta);
    }

    barraAnterior = barra;
    pctAnterior = pct;
    faltaAnterior = falta;
  }

  /* O #minicart-form sobrevive às atualizações (só o conteúdo dele é
     trocado), então observá-lo basta — e é bem mais barato que vigiar o
     documento inteiro. Na página /cart e no drawer existe um de cada. */
  function observar() {
    var alvos = document.querySelectorAll('#minicart-form');
    if (!alvos.length) return false;

    var observador = new MutationObserver(verificar);
    for (var i = 0; i < alvos.length; i++) {
      observador.observe(alvos[i], { childList: true, subtree: true });
    }
    return true;
  }

  function iniciar() {
    verificar();
    if (!observar()) {
      /* Carrinho ainda não montado: espera ele aparecer, uma vez só. */
      var espera = new MutationObserver(function () {
        if (observar()) {
          espera.disconnect();
          verificar();
        }
      });
      espera.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
